// @ts-nocheck
// Greif UI Kit = line-notification
import * as React from "react";

const BellLine: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M5.422 18.878q-.445 0-.752-.316a1.07 1.07 0 0 1-.306-.775q0-.46.306-.776.307-.316.752-.316h.737v-6.519q0-2.064 1.194-3.683t3.123-2.115v-.626q0-.656.443-1.113a1.45 1.45 0 0 1 1.08-.457q.639 0 1.082.457t.443 1.113v.626A5.47 5.47 0 0 1 16.65 6.49q1.191 1.616 1.191 3.686v6.52h.736q.445 0 .753.315.306.317.306.776t-.306.775-.753.316zm6.584 2.94q-.796 0-1.363-.58a1.93 1.93 0 0 1-.566-1.401h3.851q0 .82-.563 1.4-.565.582-1.36.581m-3.73-5.123h7.448v-6.519q0-1.582-1.094-2.71Q13.536 6.342 12 6.34T9.37 7.467q-1.094 1.126-1.094 2.71z"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export default React.memo(BellLine);
